import { gql } from '@apollo/client';

export const UPLOAD_STATUS_QUERY = gql`
    query scormCourse($scormCourseID: UUID!) {
        scormCourse(scormCourseID: $scormCourseID) {
            node {
                id
                name
                status
                launchUrl       
            }
        }
    }        
`;
